module.exports = __webpack_public_path__ + "img/expertchat-1665.42282039.png";